module.exports = require("is-root");